import { Box, Grid, Link, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import CardWithThumbnail from "src/components/thumbnail";

const PackageAttachments = ({ package_files }) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <Box>
          {package_files.length > 0 && (
            <>
              <Box>
                <Typography
                  sx={{
                    color: "#6E757C",
                    fontFamily: "var(--font-grenettepromedium)",
                    fontSize: "11px",
                    fontStyle: "normal",
                    lineHeight: "14px",
                    letterSpacing: "0.77px",
                    textTransform: "uppercase",
                  }}
                >
                  {package_files?.length} {t("package.label.attachments")}
                </Typography>
              </Box>
              <Box>
                {package_files.map((attachment, key) => {
                  return (
                    <Box key={key}>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "14px",
                          lineHeight: "31px",
                          color: "#4A5266",
                          mt: "16px",
                          mb: "12px",
                        }}
                      >
                        {attachment?.description}
                      </Typography>

                      <Box>
                        {attachment?.uploaded_files?.length > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              gap: "12px",
                              flexWrap: "wrap",
                            }}
                          >
                            {attachment?.uploaded_files.map((file, fileKey) => {
                              return (
                                <Box key={fileKey}>
                                  <CardWithThumbnail file={file} />
                                </Box>
                              );
                            })}
                          </Box>
                        )}
                      </Box>

                      {attachment?.link && (
                        <Box sx={{ mt: "12px" }}>
                          <Typography
                            sx={{
                              color: "#6E757C",
                              fontFamily: "var(--font-grenettepromedium)",
                              fontSize: "11px",
                              fontStyle: "normal",
                              lineHeight: "14px",
                              letterSpacing: "0.77px",
                              textTransform: "uppercase",
                            }}
                          >
                            {t("package.label.link")}
                          </Typography>

                          <Link
                            sx={{
                              fontWeight: 500,
                              fontSize: "14px",
                              lineHeight: "24px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              window.open(attachment?.link, "__blank");
                            }}
                          >
                            {attachment?.link}
                          </Link>
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Box>
            </>
          )}
        </Box>
      </Grid>
    </>
  );
};

export default PackageAttachments;
